import { Injectable, Inject, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { MerchantsService } from '../services/merchants.service';

@Injectable({
    providedIn: 'root',
})
export class ShowReportsGuard {
    private merchantService = inject(MerchantsService);
    public currentMerchant = toSignal(this.merchantService.activeMerchant);
    constructor(
        @Inject(PLATFORM_ID) protected platformId,
        private router: Router,
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let user = null;

        if (isPlatformBrowser(this.platformId)) {
            user = localStorage?.getItem('currentUser');
        }

        if (user) {
            const parsedUser = JSON.parse(user);

            if (parsedUser?.role === 'admin' && !this.currentMerchant()?.hideStats) {
                return true;
            }

            if (parsedUser?.role === 'manager' && !this.currentMerchant()?.hideStats && this.currentMerchant()?.showStatsToManagers) {
                return true;
            }
        }

        this.router.navigateByUrl('/');

        return false;
    }

    canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(next, state);
    }
}
